// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"S0-z","displaySixCardTiles":"T0-z"};